import { Radio } from '@mui/material';
import { Text } from '..';
import { CSSProperties } from 'react';
import { RadioSelectedIcon, RadioUnselectedIcon } from '@assets/iconComponents';

interface IRadioItemProps {
  label: string;
  value: string;
  imageComponent?: React.ReactNode;
  onChange: (value: any) => void;
  boxstyle?: CSSProperties;
}

export const RadioItem = (props: IRadioItemProps) => {
  const { label, value, imageComponent, onChange, boxstyle } = props;

  return (
    <>
      {imageComponent ? (
        <div
          onClick={() => {
            onChange(value);
          }}
          style={boxstyle ? boxstyle : { cursor: 'pointer', width: 100 }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-start',
              marginBottom: '6px'
            }}
          >
            {imageComponent}
          </div>
          <div style={{ display: 'flex' }}>
            <Radio
              value={value}
              checkedIcon={<RadioSelectedIcon style={{ width: 20, height: 20 }} />}
              icon={<RadioUnselectedIcon style={{ width: 20, height: 20 }} />}
            />
            <Text variant="body1">{label}</Text>
          </div>
        </div>
      ) : (
        <div
          onClick={() => {
            onChange(value);
          }}
          style={boxstyle ? boxstyle : { cursor: 'pointer', width: 100 }}
        >
          <div style={{ display: 'flex' }}>
            <Radio
              value={value}
              checkedIcon={<RadioSelectedIcon style={{ width: 20, height: 20 }} />}
              icon={<RadioUnselectedIcon style={{ width: 20, height: 20 }} />}
            />
            <Text variant="body1">{label}</Text>
          </div>
        </div>
      )}
    </>
  );
};
